import { useState, useContext } from "react";
import { getEmbedding, fetchArticlesByEmbedding } from "@/api/utils";
import { NewsletterContext } from "../context/NewsletterContext";

export interface searchRequirements {
  query: string;
  searchMode: "summary" | "full";
  daysAgo: number;
  MATCH_COUNT?: number;
}

export const useNLSearch = () => {
  const [isSearching, setIsSearching] = useState(false);
  const [searchError, setSearchError] = useState<string | null>(null);
  const { updatePreview } = useContext(NewsletterContext);
  const searchForArticles = async (searchRequirements: searchRequirements) => {
    const { query, searchMode, daysAgo, MATCH_COUNT } = searchRequirements;

    try {
      setIsSearching(true);
      const embedding = await getEmbedding(query);
      if (!embedding) {
        throw new Error("Failed to generate embedding");
      }
      const articles = await fetchArticlesByEmbedding({
        embedding,
        daysAgo: daysAgo,
        searchMode,
        matchCount: MATCH_COUNT,
      });
      console.log("About to call updatePreview with articles:", articles); // Debug log

      updatePreview({
        subject: "",
        body: "",
        articles: [...articles],
      });
      console.log("Called updatePreview"); // Debug log
      return articles;
    } catch (error) {
      console.error("Search failed:", error);
      setSearchError("Search failed. Please try again later.");
    } finally {
      setIsSearching(false);
    }
  };

  return {
    searchForArticles,
    isSearching,
    searchError,
  };
};
